<template>
  <div>
    <!--기본정보-->
    <field-select-module
      class="mb-6"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      title="작성자 정보"
      :types="['project_name', 'department', 'com_name', 'rank', 'writer_name', 'date']"
    />

    <!--    하도급업체 정보-->
    <div class="mb-6">
      <h5 class="mb-4"><i class="dot"></i>하도급업체 정보</h5>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">현장명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_1 }} </span>
          <field-selector
            v-else
            :readonly="board.readonly"
            :field-name="form.field.field_name"
            class="w-full flex-1"
            v-model="form.inputA_1"
            @select="handleFieldChange"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">업체명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_2 }} </span>
          <company-selector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputA_2"
            :listOnly="false"
            @select="handleCompanyChange"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_3 }} </span>
          <ml-input
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.inputA_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업자등록번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_4 | comNumber}} </span>
          <ml-input
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.inputA_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업자등록주소</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_5 }} </span>
          <ml-input
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.inputA_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">업태</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_6 }} </span>
          <ml-input
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.inputA_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">업종</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_7 }} </span>
          <ml-input
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.inputA_7"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">담당자</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_8 }} </span>
          <ml-input
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.inputA_8"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">연락처</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_9 }} </span>
          <CommaInput
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.inputA_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업자등록증</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_10 }} </span>
          <FileUploader v-else readonly class="flex-1 w-full" v-model="form.inputA_10" />
        </div>
      </div>

      <div class="col-span-12 flex items-start mt-4">
        <div class="label-text mr-4">내용</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputA_11 }} </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputA_11"
          :readonly="board.readonly"
        />
      </div>
    </div>


    <!--    시스템 사용자 정보-->
    <div class="mb-6">
      <div class="flex" style="align-items: center;">
        <h5 class="mb-4">
          <i class="dot"></i>시스템 사용자 정보
          <span class="ml-2" style="font-weight: 400; font-size: 14px; color: #696D71;">※ 입력 즉시 ID가 생성되며, 참여 종료일이 지난 즉시 접속이 차단됩니다.</span>
        </h5>
        <div class="ml-auto">
          <vs-button class="ml-4" color="secondary" @click="addUser">
            항목추가
          </vs-button>
          <vs-button
            class="ml-4"
            color="secondary"
            type="border"
            @click="removeUser"
          >
            선택삭제
          </vs-button>
        </div>
      </div>
      <div class="mt-6 user-grid">
        <div class="head" @click.stop="handleClickUserAll"><vs-checkbox :checked="userAllCheck"/></div>
        <div class="head">No.</div>
        <div class="head">사용자명</div>
        <div class="head">사용자 ID</div>
        <div class="head">비밀번호</div>
        <div class="item">연락처</div>
        <div class="head">이메일</div>
        <div class="head">참여기간</div>
      </div>

      <div class="user-grid" v-for="(user, uIndex) in form.userList">
        <div class="item"><vs-checkbox class="w-full" v-model="user.is_checked"/></div>
        <div class="item">{{ uIndex + 1 }}</div>
        <div class="item"><ml-input class="w-full" v-model="user.name"/></div>
        <div class="item"><ml-input class="w-full" v-model="user.nickname"/></div>
        <div class="item"><ml-input class="w-full" v-model="user.password" type="password"/></div>
        <div class="item"><ml-input class="w-full" v-model="user.phone"/></div>
        <div class="item"><ml-input class="w-full" v-model="user.email"/></div>
        <div class="item">
          <date-selector v-model="user.startDate"/>
          <span class="mx-2">~</span>
          <date-selector v-model="user.endDate"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanySelector from '@/components/selector/CompanySelector.vue'
import FieldSelector from '@/components/selector/FieldSelector.vue'
import TimeSelector from '@/components/selector/TimeSelector.vue'

export default {
  components: {
    TimeSelector,
    FieldSelector,
    CompanySelector,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    userAllCheck () {
      let all = this.form.userList.length > 0;
      for (const user of this.form.userList) {
        if (!user.is_checked) all = false
      }
      return all
    }
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        field: {},
        company: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: {},
        inputA_11: "",

        userList: [],

        fileList: [],
      },
    };
  },
  methods:{
    handleClickUserAll () {
      if (this.userAllCheck) {
        for (const user of this.form.userList) {
          user.is_checked = false
        }
      } else {
        for (const user of this.form.userList) {
          user.is_checked = true
        }
      }
    },
    handleFieldChange (field) {
      this.form.field = field
    },
    handleCompanyChange (company) {
      this.form.company = company

      this.form.inputA_3 = company.com_ceo // 대표자
      this.form.inputA_4 = company.com_number // 사업자등록번호
      this.form.inputA_5 = company.com_address // 사업자등록주소
      this.form.inputA_6 = company.com_business_type // 업태
      this.form.inputA_7 = company.com_business_class // 업종
      this.form.inputA_8 = company.director // 담당자
      this.form.inputA_9 = company.phone // 연락처
      this.form.inputA_10 = company.file ? company.file : {} // 사업자등록증
      this.form.inputA_11 = company.etc // 기타
    },
    addUser () {
      this.form.userList.push({
        name: '',
        nickname: '',
        password: '',
        phone: '',
        email: '',
        startDate: '',
        endDate: '',
        is_checked: false,
      })
    },
    removeUser () {
      for (let i = 0; i < this.form.userList.length; i++) {
        if (this.form.userList[i].is_checked) {
          this.form.userList.remove(this.form.userList[i])
          i = -1
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 16px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

.user-grid {
  display: grid;
  grid-template-columns: 40px 50px 1fr 1fr 1fr 1fr 1fr 2fr;
  column-gap: 12px;

  justify-content: center;
  align-items: center;
  text-align: center;

  border-top: 1px solid #CDCDCD;

  .head, .item { display: flex; justify-content: center; align-items: center; height: 50px; }
}
.user-grid:last-child {
  border-bottom: 1px solid #CDCDCD;
}
</style>
